import { SalesSummary } from '@sales/models/sales-summary';
import { Selector } from '@ngxs/store';
import { SaleState, SaleStateModel } from './sale.state';
import { EmergencyAlert } from '@app/core/models/emergency-alert-response.model';

export class SaleSelectors {
  @Selector([SaleState])
  static getState(state: SaleStateModel): SaleStateModel {
    return state;
  }

  @Selector([SaleState])
  static hasActiveSale(state: SaleStateModel): boolean {
    return state.hasActiveSale;
  }

  @Selector([SaleState])
  static getSalesSummary(state: SaleStateModel): SalesSummary {
    return state.summary;
  }

  @Selector([SaleState])
  static getEmergencyAlerts(state: SaleStateModel): EmergencyAlert[] {
    return state.emergencyAlertResponse?.alertList;
  }
}
